<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
    @if(processing() ) {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }
    @if(alert) {
      <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
    }
    
    @if(!processing() && pool) {
      <app-competition-timeline [competitionConfig]="pool.getCompetitionConfig()"></app-competition-timeline>
      <div>
        <div class="d-flex justify-content-between mb-3">
          <h2 class="me-2 text-truncate">
            <fa-icon [icon]=faUsers></fa-icon> {{pageTitle()}}
          </h2>
          @if(!isSourceCompetition) {
            <button (click)="myNavigation.back()" type="button" class="btn btn-outline-dark">
              <fa-icon [icon]=faLevelUpAlt [rotate]="270"></fa-icon>
              <span class="ms-1 d-none d-md-inline"> terug</span>
            </button>
          }
        </div>

        <div class="d-flex justify-content-center">
          <app-pool-player-choose class="w-100" (selectS11Player)="openAddModal(pool, $event)"
            [selectableLines]="selectableLines"
            [competitionConfig]="pool.getCompetitionConfig()" [selectableTeams]="selectableTeams"
            [viewPeriod]="pool.getCreateAndJoinPeriod()" [viewPeriodType]="AssembleViewPeriod"
            [showSelectButton]="!isSourceCompetition"
            [maxResults]="isSourceCompetition ? null : 50"
            [alreadyChosenPersons]="getPersons()" (linkToS11Player)="linkToPlayer(pool, $event)"
            (filterUpdate)="updateState($event)" [filter]="choosePlayersFilter">
          </app-pool-player-choose>
          <!-- <app-s11player-info></app-s11player-info> -->
        </div>
      </div>
    }
  </div>
</div>

@if(!processing() && pool) {
<app-pool-navbar [current]="Scouting" [pool]="pool" [poolUser]="poolUserFromSession">
</app-pool-navbar>
}
